export default "__VITE_ASSET__e3687ab9__"